import { AppProvider, useAppState } from './hooks/useAppState';
import { SplashPage } from './pages/SplashPage';
import { IdentityPage } from './pages/IdentityPage';
import { SceneFlowPage } from './pages/SceneFlowPage';
import { AllScenesPage } from './pages/AllScenesPage';
import { BottomNav } from './components/BottomNav';

function Router(): JSX.Element {
  const { state } = useAppState();

  const pages: Record<string, JSX.Element> = {
    splash: <SplashPage />,
    identity: <IdentityPage />,
    sceneFlow: <SceneFlowPage />,
    allScenes: <AllScenesPage />,
  };

  const showNav = state.currentPage !== 'splash';

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      background: '#f5f5f7',
      color: '#1a1a1c',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif',
      WebkitFontSmoothing: 'antialiased',
    }}>
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {pages[state.currentPage] || <SplashPage />}
      </div>
      {showNav && <BottomNav />}
    </div>
  );
}

export function App(): JSX.Element {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
}
